import React, { useState, useEffect } from "react";
import { createOktaImportFlowPayload } from "../payload/okta.flow";
import {
  createCredRef,
} from "../../../../../../common/factory/credential.factory";
import { saveFlow } from "../../../../../../redux/actions/integrationActions";
import {
  setCurrentWizardData,
} from "../../../../../../redux/actions/wizardActions";
import { useDispatch, useSelector } from "react-redux";
import LoadingIndicator from "../../../../common/LoadingIndicator";
import SuccessIndicator from "../../../../common/SuccessIndicator";
/**
 * The useEffect will start the creation.
 * It calls the function to create the flows
 * 
 */
const CreateOktaImportFlow = () => {
  const dispatch = useDispatch();
  const currentData = useSelector((state) => state.wizard.currentData);
  const workspace = useSelector((state) => state.jiraAssets.workspace);
  const token = useSelector((state) => state.jiraAssets.token);
  
  const importSource = useSelector((state) => state.jiraAssets.importSource);
  const selectedAssetSchema = useSelector(
    (state) => state.jiraAssets.selectedAssetSchema
  );
  const importSourceName = useSelector(
    (state) => state.jiraAssets.importSourceName
  );
 

  /**
   * The function creating the flow after credentials are created
   * @param {*} basicAuth 
   * @param {*} tokenAuth 
   */
  const createIntegrationFlow = () => {
    //breaking condition if loop, do not remove!
    if(currentData?.ihubConfigIsCreated){
      return false;
    }
    
    const flowPayload = createOktaImportFlowPayload(
      currentData.cron, 
      importSourceName,
      selectedAssetSchema,
      currentData,
      workspace,
      importSource.id,
      createCredRef(currentData?.importCredentialsReferences?.assetImportTokenRefId),
      createCredRef(currentData?.importCredentialsReferences?.oktaCredRef)
    );
    dispatch(saveFlow(flowPayload, false));
    const updatedData = {
      ...currentData,
      ihubConfigIsCreated: true,
    };
    dispatch(setCurrentWizardData(updatedData));
  };
  // Send saveCred twice and log their IDs
  useEffect(() => {
    if (
      !currentData?.ihubConfigIsCreated &&
      workspace &&
      importSource &&
      selectedAssetSchema &&
      importSourceName &&
      token &&
      currentData?.importCredentialsReferences && 
      currentData?.importCredentialsReferences?.assetImportTokenRefId &&
      currentData?.importCredentialsReferences?.oktaCredRef

    ) {
      
      createIntegrationFlow()
    }
  }, [currentData,token]);


  return (
    <>
      <LoadingIndicator currentData={currentData} />
      <SuccessIndicator currentData={currentData} />
    </>
  );
};
export default CreateOktaImportFlow;